import { IContentHubClient } from "../../clients/content-hub-client";
import Guard from "../../guard";
import { IEntityLoadConfiguration } from "./entity-load-configuration";
import { IEntityQueryResult } from "./entity-query-result";
import { LoadingQueryIteratorBase } from "./loading-query-iterator";
import { Query } from "./query";
import { IQueryIterator } from "./query-iterator";

export type IEntityIterator = IQueryIterator<IEntityQueryResult>;

export class EntityIterator extends LoadingQueryIteratorBase<IEntityQueryResult> implements IEntityIterator {
    private readonly _client: IContentHubClient;

    constructor(
        client: IContentHubClient,
        query: Query,
        loadConfiguration: IEntityLoadConfiguration,
        result?: IEntityQueryResult
    ) {
        super(query, loadConfiguration, result);

        Guard.notNullOrUndefined(client);
        this._client = client;
    }

    async getResultAsync(query: Query, loadConfiguration: IEntityLoadConfiguration): Promise<IEntityQueryResult> {
        return this._client.querying.queryAsync(query, loadConfiguration);
    }
}
